module.exports = __webpack_public_path__ + "static/media/icons8-whatsapp.214dff34.svg";